import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
// import * as Sentry from '@sentry/angular';

// Sentry.init({
//   dsn: 'https://1d8cf615d6e9dc93dc931e643d4b6a8e@sentry.somjai.app/8',
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration({
//       // Network detail configuration for debugging
//       networkDetailAllowUrls: [window.location.origin, /^https:\/\/.*\.somjai\.app/],

//       // Request headers to capture (only necessary ones for debugging)
//       networkRequestHeaders: [
//         'Content-Type',       // Request content type
//         'X-Request-ID',       // Backend-generated request ID (from request-id.middleware.ts)
//       ],

//       // Response headers to capture (only necessary ones for debugging)
//       networkResponseHeaders: [
//         'Content-Type',       // Response content type
//         'X-Request-ID',       // Backend-generated request ID (from request-id.middleware.ts)
//       ],

//       // Note: Sentry automatically redacts sensitive headers like Authorization
//       // Do NOT add all headers to avoid:
//       // 1. Sending sensitive data (cookies, tokens, internal headers)
//       // 2. Increasing Sentry storage costs
//       // 3. Creating noise in debugging
//     }),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Capture 100% of transactions
//   tracePropagationTargets: ['localhost', /^https:\/\/.*\.somjai\.app/],
//   // Session Replay
//   replaysSessionSampleRate: 1.0, // 100% of sessions
//   replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors
//   // Release tracking
//   release: '1.3.5',
//   environment: 'production',
// });

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
